var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$root.currentUser === null || !_vm.$root.currentUser.premium)?_c('ins',{staticClass:"adsbygoogle",staticStyle:{"z-index":"99"},style:(_vm.adStyle),attrs:{"data-ad-client":_vm.adClient,"data-ad-format":_vm.adFormat,"data-ad-slot":_vm.adSlot,"data-full-width-responsive":"true"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }